import {
  Box,
  LinkBox,
  LinkOverlay,
  LinkProps,
  useMultiStyleConfig,
  VStack,
} from '@chakra-ui/react';
import React from 'react';

import { isExternalLink } from '../../../utils/link.utils';
import Button from '../../Button';
import { LocationIcon } from '../../Icons';
import type { WLIconProps } from '../../Icons/icon.props.interface';

interface IconCardProps {
  buttonText: string;
  href: LinkProps['href'];
  icon?: React.ComponentType<WLIconProps>;
  iconColor?: string;
}

const IconCard: React.FC<IconCardProps> = ({
  children,
  buttonText,
  href,
  icon = LocationIcon,
  iconColor = 'red.800',
}) => {
  const IconElement = icon;
  const styles = useMultiStyleConfig('IconCard', {});
  return (
    <LinkBox as={Box} sx={styles.container}>
      <Box sx={styles.icon}>
        <IconElement
          boxSize="60px"
          variant="darkIconNoBackground"
          color={iconColor}
        />
      </Box>
      <VStack>
        {children}
        <LinkOverlay
          as={Button}
          variant="outline"
          colorScheme="red"
          capitalize
          href={href}
          aria-label={buttonText}
          isExternal={isExternalLink(href)}
        >
          {buttonText}
        </LinkOverlay>
      </VStack>
    </LinkBox>
  );
};

export default IconCard;
